/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PromptLibraryItem } from './PromptLibraryItem';
import {
    PromptLibraryItemFromJSON,
    PromptLibraryItemFromJSONTyped,
    PromptLibraryItemToJSON,
    PromptLibraryItemToJSONTyped,
} from './PromptLibraryItem';

/**
 * 
 * @export
 * @interface PromptLibrarySubcategory
 */
export interface PromptLibrarySubcategory {
    /**
     * 
     * @type {string}
     * @memberof PromptLibrarySubcategory
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PromptLibrarySubcategory
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof PromptLibrarySubcategory
     */
    icon?: string;
    /**
     * 
     * @type {Array<PromptLibraryItem>}
     * @memberof PromptLibrarySubcategory
     */
    items: Array<PromptLibraryItem>;
}

/**
 * Check if a given object implements the PromptLibrarySubcategory interface.
 */
export function instanceOfPromptLibrarySubcategory(value: object): value is PromptLibrarySubcategory {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function PromptLibrarySubcategoryFromJSON(json: any): PromptLibrarySubcategory {
    return PromptLibrarySubcategoryFromJSONTyped(json, false);
}

export function PromptLibrarySubcategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromptLibrarySubcategory {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'items': ((json['items'] as Array<any>).map(PromptLibraryItemFromJSON)),
    };
}

export function PromptLibrarySubcategoryToJSON(json: any): PromptLibrarySubcategory {
    return PromptLibrarySubcategoryToJSONTyped(json, false);
}

export function PromptLibrarySubcategoryToJSONTyped(value?: PromptLibrarySubcategory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'icon': value['icon'],
        'items': ((value['items'] as Array<any>).map(PromptLibraryItemToJSON)),
    };
}

